import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async buscarOrcamentoEdicao(axios, parametros) {        
    parametros.operacao = 'buscarOrcamentoEdicao'

    let retorno = {}

    await axios.santriGET('/rest/orcamento', parametros, 90, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data)
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined)
    })

    return retorno
  },
}


// WEBPACK FOOTER //
// ./src/components/Rest/ROrcamento/ROrcamentoBuscarOrcamentoEdicao.js